import { useMemo } from 'react'
import { Box } from '@material-ui/core'
import { Label } from '@noco/http-client/lib/noco'

import { Typography } from '../Typography'

export interface DocumentLabelItemProps {
  /** Labelオブジェクト */
  label?: Label
  /** 後方互換性のためのラベル名（labelが指定されていない場合に使用） */
  value?: string
}

/** 既存のハードコードされたラベル名に対応する色マップ（後方互換性のため） */
const labelColorMap: { [key in string]: string } = {
  営業資料: '#CFEDC6',
  ホワイトペーパー: '#C5E9F2',
  カタログ: '#CADFFF',
  会社案内: '#FFEDBE',
  採用資料: '#FDD5E6',
  ガイドライン: '#FFC7C7',
  'マニュアル・手順書': '#E7D3F3',
  社外秘: '#EBCDCD',
  その他: '#E3E7ED'
}

export const DEFAULT_LABEL_COLOR = '#E3E7ED'

export const DocumentLabelItem = ({ label, value }: DocumentLabelItemProps) => {
  const displayName = useMemo(() => {
    return label?.name || value || ''
  }, [label, value])

  const color = useMemo(() => {
    // Labelオブジェクトがあればそのcolorを使用
    if (label?.color) return label.color
    // 後方互換性：ラベル名から色を取得
    if (value) return labelColorMap[value] || DEFAULT_LABEL_COLOR
    return DEFAULT_LABEL_COLOR
  }, [label, value])

  if (!displayName) return null

  return (
    <Box display="inline-block" borderRadius="4px" py="4px" px="8px" bgcolor={color} lineHeight="14px">
      <Typography fontSize="s" lineheight="14px" noWrap>
        {displayName}
      </Typography>
    </Box>
  )
}
